import { render, staticRenderFns } from "./KidsInfoData.vue?vue&type=template&id=3a58c954&scoped=true"
import script from "./KidsInfoData.vue?vue&type=script&lang=js"
export * from "./KidsInfoData.vue?vue&type=script&lang=js"
import style0 from "./KidsInfoData.vue?vue&type=style&index=0&id=3a58c954&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a58c954",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a58c954')) {
      api.createRecord('3a58c954', component.options)
    } else {
      api.reload('3a58c954', component.options)
    }
    module.hot.accept("./KidsInfoData.vue?vue&type=template&id=3a58c954&scoped=true", function () {
      api.rerender('3a58c954', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/KidsInfoData.vue"
export default component.exports